import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading } from "components/misc/Headings.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import defaultCardImage from "../../images/shield-icon.svg";

import { ReactComponent as SvgDecoratorBlob3 } from "../../images/svg-decorator-blob-3.svg";

import SupportIconImage from "../../images/support-icon.svg";
import ShieldIconImage from "../../images/shield-icon.svg";
import CustomizeIconImage from "../../images/simple-icon.svg";
import FastIconImage from "../../images/fast-icon.svg";
import ReliableIconImage from "../../images/reliable-icon.svg";
import SimpleIconImage from "../../images/simple-icon.svg";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";


// const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-20 md:py-24`}
`;
const Heading = tw(SectionHeading)`w-full`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 px-6 flex`}
`;

const Card = styled.div`
  ${tw`flex flex-col mx-auto max-w-xs items-center px-6 py-10 border-2 border-dashed border-primary-500 rounded-lg mt-12`}
  .imageContainer {
    ${tw`border-2 border-primary-500 text-center rounded-full p-6 flex-shrink-0 relative`}
    img {
      ${tw`w-8 h-8`}
    }
  }

  .textContainer {
    ${tw`mt-6 text-center`}
  }

  .title {
    ${tw`mt-2 font-bold text-xl leading-none text-primary-500`}
  }

  .description {
    ${tw`mt-3 font-semibold text-secondary-100 text-sm leading-loose`}
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;
const PrimaryButton = styled(PrimaryButtonBase)(props => [
  tw`mt-8 md:mt-8 text-sm inline-block mx-auto md:mx-0 place-content-around
  `,
  props.buttonRounded && tw`rounded-full`
]);

export default ({

  primaryButtonText = "Alla våra bilar",
  primaryButtonUrl = "/alla-bilar",
  buttonRounded = true,

}) => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component):
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const cards = [
    {
      imageSrc: ShieldIconImage,
      title: "Garantier",
      description: "Vi erbjuder marknadens bästa garantier genom AB Svensk Bilgaranti.  Läs mer här."
    },
    { imageSrc: SupportIconImage, title: "Finansering", description: "Nyckeln till en bra bilaffär beror till stor del på hur finansieringslösningen ser ut. Genom vårt samarbete med Wasa Kredit och Nordea Finans, får du möjlighet att äga eller leasa den bil som passar just dina önskemål och krav från 0 kr kontantinsats." },
   
  ];

  window.postId = 9

  return (
    <Container>
      <ContentWithPaddingXl>
     
        
        <Heading>Våra  <span tw="text-orange-500" 
        // style={{color:'#F98D38 !important'}}
        >senaste bilar</span></Heading>
        <div style={{width: '90%'}}></div>
        <div id="tfap-root" className="tfap-app"></div>
        
      <div style={{display:"grid", gridColumn:"1fr 1fr 1fr", justifyContent:"center"}}>
          <PrimaryButton buttonRounded={buttonRounded} as="a" href={primaryButtonUrl}>
            {primaryButtonText}
          </PrimaryButton>   
          </div>
      </ContentWithPaddingXl>
    </Container>
  );
};
